
export default {

    //获取链接参数
    GetQueryString: function (name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]); return null;
    },
    //检查是否为微信浏览器
    checkWindow: function () {
        var u = navigator.userAgent, app = navigator.appVersion;
        var data = {
            trident: u.indexOf('Trident') > -1, //IE内核
            presto: u.indexOf('Presto') > -1, //opera内核
            webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
            iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
            webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
            weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
            qq: u.match(/\sQQ/i) == " qq", //是否QQ
            baidu: u.indexOf('baiduboxapp') > -1 //是否百度浏览器
        };
        return data;
    },
    testApp: function (url) {
        var timeout, t = 1000, hasApp = true;
        setTimeout(function () {
            if (hasApp) {
                alert('安装了app');
            } else {
                alert('未安装app');
            }
            document.body.removeChild(ifr);
        }, 2000)

        var t1 = Date.now();
        var ifr = document.createElement("iframe");
        ifr.setAttribute('src', url);
        ifr.setAttribute('style', 'display:none');
        document.body.appendChild(ifr);
        timeout = setTimeout(function () {
            var t2 = Date.now();
            if (!t1 || t2 - t1 < t + 100) {
                hasApp = false;
            }
        }, t);
    },
    // 获取昨日时间段
    getYesterday: function () {
        var day1 = new Date();
        day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000);
        var year, month, day;
        year = day1.getFullYear();
        month = day1.getMonth() + 1;
        day = day1.getDate();
        if (month < 10) {
            month = "0" + month.toString();
        }

        if (day < 10) {
            day = "0" + day.toString();
        }
        var s1 = year + "-" + month + "-" + day;
        var dateTime = new Array();
        dateTime[0] = s1;
        dateTime[1] = s1;
        return dateTime;
    },
    // 获取昨日时间段
    getToday: function () {
        var day1 = new Date();
        day1.setTime(day1.getTime());
        var year, month, day;
        year = day1.getFullYear();
        month = day1.getMonth() + 1;
        day = day1.getDate();
        if (month < 10) {
            month = "0" + month.toString();
        }

        if (day < 10) {
            day = "0" + day.toString();
        }
        var s1 = year + "-" + month + "-" + day;
        var dateTime = new Array();
        dateTime[0] = s1;
        dateTime[1] = s1;
        return dateTime;
    },
    getUTime:function(data,type){
        var _data = data;
        if(data == ""){
            return ""
        }
        //如果是13位正常，如果是10位则需要转化为毫秒
        if (String(data).length == 13) {
          _data = data
        } else {
          _data = data*1000
        }
        const time = new Date(_data);    
        const Y = time.getFullYear();
        const Mon = time.getMonth() + 1;
        const Day = time.getDate();
        const H = time.getHours();
        const Min = time.getMinutes();
        const S = time.getSeconds();
        //自定义选择想要返回的类型
        if(type=="Y"){
          return `${Y}-${Mon}-${Day}`
        }else if(type=="H"){
          return `${H}:${Min}:${S}`
        }else{
          return `${Y}-${Mon}-${Day} ${H}:${Min}:${S}`
        }
    },
    updateJindou:function (val){
        return val/100;
    },
    getByteLen:function(val) {
        var len = 0;
        for (var i = 0; i < val.length; i++) {
        var length = val.charCodeAt(i);
        if(length>=0&&length<=128)
        {
        len += 1;
        }
        else
        {
        len += 2;
        }
        }
        return len;
    }
}

